export default __webpack_public_path__ + "static/media/3.3c5928d3.jpg";